import script from "./AppToast.vue?vue&type=script&setup=true&lang=js"
export * from "./AppToast.vue?vue&type=script&setup=true&lang=js"

import "./AppToast.vue?vue&type=style&index=0&id=545f6a92&lang=scss"

const __exports__ = script;

export default __exports__